// import React, { useState } from "react";

// const LocationFilter = () => {
//   const [formData, setFormData] = useState({
//     searchTerm: "",
//     selectedLocations: [],
//   });

//   // Sample locations
//   const locations = [
//     "Indiranagar - Metro Station (NearMe..)",
//     "Yeshwanthpur (BMTC Bus Station)",
//     "Koramangala (Beside Sony Signal)",
//     "Majestic (Opp to POTHYS)",
//     "Bellandur (Adarsh Palm Retreat)",
//     "Hebbal (Presidency College)",
//     "Bannerghatta Road",
//     "BTM 2nd Stage",
//   ];

//   // Handle search input change
//   const handleSearch = (e) => {
//     setFormData((prevData) => ({
//       ...prevData,
//       searchTerm: e.target.value,
//     }));
//   };

//   // Handle checkbox toggle
//   const toggleLocation = (location) => {
//     setFormData((prevData) => {
//       const updatedLocations = prevData.selectedLocations.includes(location)
//         ? prevData.selectedLocations.filter((loc) => loc !== location)
//         : [...prevData.selectedLocations, location];

//       return {
//         ...prevData,
//         selectedLocations: updatedLocations,
//       };
//     });
//   };

//   // Handle form submission
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log("Submitted Data:", formData);
//     // Add logic to handle form submission, like API calls or state updates
//   };

//   // Filter locations based on search term
//   const filteredLocations = locations.filter((location) =>
//     location.toLowerCase().includes(formData.searchTerm.toLowerCase())
//   );

//   return (
//     <form onSubmit={handleSubmit} className="p-4 bg-white rounded-md shadow-md max-w-md mx-auto">
//       <div className="mb-4">
//         {/* Search Input */}
//         <div className="relative">
//           <input
//             type="text"
//             placeholder="Search Location"
//             value={formData.searchTerm}
//             onChange={handleSearch}
//             className="w-full border rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//           />
//           <span className="absolute top-2 right-3 text-gray-500">
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               fill="none"
//               viewBox="0 0 24 24"
//               strokeWidth="2"
//               stroke="currentColor"
//               className="w-5 h-5"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 d="M21 21l-4.35-4.35M16.65 11.65a5 5 0 11-10 0 5 5 0 0110 0z"
//               />
//             </svg>
//           </span>
//         </div>
//       </div>

//       {/* Location List */}
//       <div className="h-64 overflow-y-auto">
//         {filteredLocations.map((location, index) => (
//           <div key={index} className="flex items-center space-x-2 py-2">
//             <input
//               type="checkbox"
//               id={`location-${index}`}
//               checked={formData.selectedLocations.includes(location)}
//               onChange={() => toggleLocation(location)}
//               className="w-4 h-4 text-[#FF9630] border-gray-300 rounded focus:ring-[#FF9630]"
//             />
//             <label
//               htmlFor={`location-${index}`}
//               className="text-sm text-gray-800"
//             >
//               {location}
//             </label>
//           </div>
//         ))}
//       </div>

//       {/* Buttons */}
//       <div className="mt-6 flex space-x-4">
//         <button
//           type="button"
//           onClick={() =>
//             setFormData({
//               searchTerm: "",
//               selectedLocations: [],
//             })
//           }
//           className="flex-1 py-2 text-[#FF9630] border border-[#FF9630] rounded-md font-medium"
//         >
//           Clear
//         </button>
//         <button
//           type="submit"
//           className="flex-1 py-2 bg-[#FF9630] text-white rounded-md font-medium"
//         >
//           Add to Filter
//         </button>
//       </div>
//     </form>
//   );
// };

// export default LocationFilter;




// import React, { useState } from "react";
// const LocationFilter = ({ onSelect }) => {
//   const [formData, setFormData] = useState({
//     searchTerm: "",
//     selectedLocations: [],
//   });

//   const locations = [
//     "Indiranagar - Metro Station (NearMe..)",
//     "Yeshwanthpur (BMTC Bus Station)",
//     "Koramangala (Beside Sony Signal)",
//     "Majestic (Opp to POTHYS)",
//     "Bellandur (Adarsh Palm Retreat)",
//     "Hebbal (Presidency College)",
//     "Bannerghatta Road",
//     "BTM 2nd Stage",
//   ];

//   const handleSearch = (e) => {
//     setFormData((prevData) => ({
//       ...prevData,
//       searchTerm: e.target.value,
//     }));
//   };

//   const toggleLocation = (location) => {
//     setFormData((prevData) => {
//       const updatedLocations = prevData.selectedLocations.includes(location)
//         ? prevData.selectedLocations.filter((loc) => loc !== location)
//         : [...prevData.selectedLocations, location];

//       return {
//         ...prevData,
//         selectedLocations: updatedLocations,
//       };
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     onSelect(formData.selectedLocations); // Pass selected locations to parent
//   };

//   const filteredLocations = locations.filter((location) =>
//     location.toLowerCase().includes(formData.searchTerm.toLowerCase())
//   );

//   return (
//     <>
//     <form onSubmit={handleSubmit} className="p-4 bg-white rounded-md shadow-md  max-w-md mx-auto">
//       {/* Search Input */}
//       <div className="mb-4">
//         <input
//           type="text"
//           placeholder="Search Location"
//           value={formData.searchTerm}
//           onChange={handleSearch}
//           className="w-full border rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//         />
//       </div>

//       {/* Location List */}
//       <div className="h-64 overflow-y-auto">
//         {filteredLocations.map((location, index) => (
//           <div key={index} className="flex items-center space-x-2 py-2">
//             <input
//               type="checkbox"
//               id={`location-${index}`}
//               checked={formData.selectedLocations.includes(location)}
//               onChange={() => toggleLocation(location)}
//               className="w-4 h-4 text-[#FF9630] border-gray-300 rounded focus:ring-[#FF9630]"
//             />
//             <label htmlFor={`location-${index}`} className="text-sm text-gray-800">
//               {location}
//             </label>
//           </div>
//         ))}
//       </div>

//       {/* Buttons */}
//       <div className="mt-6 flex space-x-4">
//         <button
//           type="button"
//           onClick={() =>
//             setFormData({
//               searchTerm: "",
//               selectedLocations: [],
//             })
//           }
//           className="flex-1 py-2 text-[#FF9630] border border-[#FF9630] rounded-md font-medium"
//         >
//           Clear
//         </button>
//         <button
//           type="submit"
//           className="flex-1 py-2 bg-[#FF9630] text-white rounded-md font-medium"
//         >
//           Add to Filter
//         </button>
//       </div>
//     </form>
//     </>
//   );
// };

// export default LocationFilter;


import React, { useState } from "react";

const LocationFilter = ({ onSelect }) => {
  const [formData, setFormData] = useState({
    searchTerm: "",
    selectedLocations: [],
  });

  const locations = [
    "Indiranagar - Metro Station (NearMe..)",
    "Yeshwanthpur (BMTC Bus Station)",
    "Koramangala (Beside Sony Signal)",
    "Majestic (Opp to POTHYS)",
    "Bellandur (Adarsh Palm Retreat)",
    "Hebbal (Presidency College)",
    "Bannerghatta Road",
    "BTM 2nd Stage",
    "Shivaji Nagar, Belgaum",
    "Tilakwadi, Belgaum",
    "Khanapur Road, Belgaum",
    "Vadgaon, Belgaum",
    "Ramteerth Nagar, Belgaum",
    "Angol, Belgaum",
  ];

  const handleSearch = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      searchTerm: e.target.value,
    }));
  };

  const toggleLocation = (location) => {
    setFormData((prevData) => {
      const updatedLocations = prevData.selectedLocations.includes(location)
        ? prevData.selectedLocations.filter((loc) => loc !== location)
        : [...prevData.selectedLocations, location];

      return {
        ...prevData,
        selectedLocations: updatedLocations,
      };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSelect(formData.selectedLocations); // Pass selected locations to parent
  };

  const filteredLocations = locations.filter((location) =>
    location.toLowerCase().includes(formData.searchTerm.toLowerCase())
  );

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <form
        onSubmit={handleSubmit}
        className="p-6 bg-white rounded-md shadow-lg max-w-md w-full min-h-screen"
      >
        {/* Search Input */}
        <div className="mb-4">
          <input
            type="text"
            placeholder="Search Location"
            value={formData.searchTerm}
            onChange={handleSearch}
            className="w-full border rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
          />
        </div>

        {/* Location List */}
        {/* <div className="border rounded-md p-2">
          {filteredLocations.map((location, index) => (
            <div key={index} className="flex items-center space-x-2 py-2">
              <input
                type="checkbox"
                id={`location-${index}`}
                checked={formData.selectedLocations.includes(location)}
                onChange={() => toggleLocation(location)}
                className="w-4 h-4 text-[#FF9630] border-gray-300 rounded focus:ring-[#FF9630]"
              />
              <label
                htmlFor={`location-${index}`}
                className="text-sm text-gray-800"
              >
                {location}
              </label>
            </div>
          ))}
        </div> */}

        <div className="border rounded-md p-2">
          {filteredLocations.map((location, index) => (
            <div key={index} className="flex items-center justify-between py-2">
              <label htmlFor={`location-${index}`} className="text-sm text-gray-800">
                {location}
              </label>
              <input
                type="checkbox"
                id={`location-${index}`}
                checked={formData.selectedLocations.includes(location)}
                onChange={() => toggleLocation(location)}
                className="w-4 h-4 text-[#FF9630] border-gray-300 rounded focus:ring-[#FF9630]"
              />
            </div>
          ))}
        </div>

        {/* Buttons */}
        <div className="mt-12 flex space-x-4 ">
          <button
            type="button"
            onClick={() =>
              setFormData({
                searchTerm: "",
                selectedLocations: [],
              })
            }
            className="flex-1 py-2 text-[#FF9630] border border-[#FF9630] rounded-md font-medium"
          >
            Clear
          </button>
          <button
            type="submit"
            className="flex-1 py-2 bg-[#FF9630] text-white rounded-md font-medium"
          >
            Add to Filter
          </button>
        </div>
      </form>
    </div>
  );
};

export default LocationFilter;
